export default {
    optionMap: {
        active: "setActive",
    },
    initialOptionMap: {
        handleEvent: "handleEvent",
    },
};
